import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const HorizontalLine = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray600};
  padding-bottom: ${rem(18)};
`;

export const SubTitle = styled.div`
  font-family: 'Open Sans', sans-serif;
  justify-content: space-between;
  display: flex;
  font-weight: 400;
  font-size: ${rem(13)};
  margin: ${rem(16)} 0 ${rem(16)} ${rem(16)};
  font-style: italic;
`;